import React, {useEffect, useState} from 'react';
import {addEmployee, getEmployeeForWorkshop} from "../../Api/Api";
import {useWorkshop} from "../Common/WorkshopContext";
import {Link} from "react-router-dom";
import EmployeeModal from "./AddEmployee";
import {FaEdit, FaUserPlus} from "react-icons/fa";
import Pagination from "../Pagination/Pagination";
import {useNotification} from "../Notification/NotificationContext";

function EmployeeList() {
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { workshopId } = useWorkshop();
    const [showModal, setShowModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const { showNotification } = useNotification();


    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = 10; // Define how many customers per page

    useEffect(() => {
        getEmployees();
    }, [workshopId, currentPage]);

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEmployee(null);
    };

    const getEmployees = () => {
        getEmployeeForWorkshop(workshopId, pageSize, currentPage)
            .then(response => {
                setEmployees    (response.data.content);
                setTotalPages(response.data.totalPages);
                setTotalCount(response.data.totalElements);
                setLoading(false);
            })
            .catch((error) => {
                showNotification(error, "error")
                setLoading(false);
            });
    };

    const handleShowModal = (employee = null) => {
        setSelectedEmployee(employee);
        setShowModal(true);
    };

    const handleSaveEmployee = async (employeeData) => {
        try {
            await addEmployee(employeeData).then(() => {
                showNotification("Employee Added Succcessfully", "success")
            }).catch(error => {
                 showNotification(error.message, "error")
            });
            getEmployees();
        } catch (error) {
             showNotification(error.message, "error")
        }
    };

    if (loading) {
        return <div className="flex justify-center items-center py-6 text-gray-600">Loading...</div>;
    }

    if (error) {
        return <div className="text-center text-red-500 py-6">{error}</div>;
    }

    return (
        <div className="mt-6 px-4 sm:px-6 lg:px-8">
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                <div className="flex items-center justify-between bg-teal-500 text-white px-6 py-4 rounded-t-xl">
                    <h2 className="text-lg font-semibold">Employee List</h2>
                    <button
                        onClick={() => handleShowModal()}
                        className="inline-flex items-center px-4 py-2 bg-white text-teal-600 border border-teal-500 rounded-md hover:bg-gray-100 transition"
                    >
                        <FaUserPlus className="mr-2" /> Add Employee
                    </button>
                </div>


                <div className="p-4 overflow-x-auto">
                    <table className="min-w-full table-auto text-sm">
                        <thead className="bg-gray-100 text-gray-700 uppercase text-xs tracking-wider">
                        <tr>
                            <th className="p-3 text-center">ID</th>
                            <th className="p-3 text-left">Name</th>
                            <th className="p-3 text-left">Position</th>
                            <th className="p-3 text-left">Actions</th>
                        </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                        {employees.map((employee) => (
                            <tr key={employee.id} className="hover:bg-gray-50">
                                <td className="p-3 text-center text-gray-700">{employee.id}</td>
                                <td className="p-3 text-blue-600 hover:underline">
                                    <Link to={`/employees/${employee.id}`}>{employee.name}</Link>
                                </td>
                                <td className="p-3">{employee.position}</td>
                                <td className="p-3">
                                    <button
                                        onClick={() => handleShowModal(employee)}
                                        className="inline-flex items-center px-3 py-1 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition"
                                    >
                                        <FaEdit className="mr-2" /> Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                    <div className="mt-4">

                        <Pagination
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                            currentPage={currentPage}
                            totalCount={totalCount}
                        />
                    </div>
                </div>
            </div>

            {/* Modal */}
            <EmployeeModal
                show={showModal}
                handleClose={handleCloseModal}
                employee={selectedEmployee}
                handleSave={handleSaveEmployee}
            />
        </div>

    );
}

export default EmployeeList;
